import type { RouterBlockerProps } from "./router-blocker.type";

import { Modal } from "antd";
import { useTranslation } from "react-i18next";
import { useBlocker } from "react-router";

export const RouterBlocker = ({
  shouldBlock,
  shouldShowModal = true,
  title,
  message,
  confirmText,
  cancelText,
  onConfirm,
}: RouterBlockerProps) => {
  const { t } = useTranslation();
  const blocker = useBlocker(shouldBlock);

  if (blocker.state !== "blocked" || !shouldShowModal) return null;

  const handleConfirm = async () => {
    await onConfirm?.();
    blocker.proceed();
  };

  const handleCancel = () => {
    blocker.reset();
  };

  return (
    <Modal
      open
      closable
      title={title}
      okType="danger"
      okText={confirmText || t("global:discardChanges")}
      cancelText={cancelText || t("global:cancel")}
      onOk={handleConfirm}
      onCancel={handleCancel}
    >
      {message}
    </Modal>
  );
};
